import React from 'react';
import classNames from 'classnames';
import styles from './sorters-button-element.module.scss';
import type { FC, ButtonHTMLAttributes } from 'react';
import { FixButton } from "@/elements-react/fix-button";
import { useTranslation } from "react-i18next";
import { Icon } from "@/elements-react/fix-icon";

export interface SortersButtonElementProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  onClick?: () => void;
}

export const SortersButtonElement = ({
  active = false,
  className,
  onClick,
  ...rest
}: SortersButtonElementProps) => {
  const { t } = useTranslation();

  return (
    <FixButton
      type={'button'}
      className={classNames(styles.root, { [styles.active]: active }, className)}
      onClick={onClick}
      size={'small'}
      variant={'default'}
      {...rest}
    >
      <Icon name="sort" className={styles.icon} />
      <span className={styles.label}>{t("ts3qxbgz137nkufi.sort-by", "Sort by")}</span>
    </FixButton>
  );
};

export default SortersButtonElement;
